import React, { useEffect, useState } from "react";

import { RedirectionContainer } from "./RedirectionStyled";
import { useUserContext } from "../../context/user/AuthContext";
import { useNavigate } from "react-router-dom";

import TermsService from "../../services/terms.service";

export interface Props {
	background?: string;
	children?: React.ReactNode;
}

const Redirection: React.FC<Props> = ({ children, background = "#FFF", ...props }) => {
	const navigate = useNavigate();
	const { userData } = useUserContext();

	const checkAndRedirect = async () => {
		const termsService = new TermsService();
		const response = await termsService.list();

		//console.log("RESPONSE => ", response);

		if (userData) {
			const userGroups = userData.grupos.split(",");
			const redirectUri = localStorage.getItem("redirectUrl");

			if (response[0]) {
				return navigate(`/contratos/${response[0].id}`); // se tiver contrato, manda pra assinar
			}

			if (redirectUri) {
				localStorage.removeItem("redirectUrl");
				return navigate(redirectUri); // se tiver uma url pra redirect, manda pra lá
			}

			if (userGroups.includes("Alunos") || userGroups.includes("NMAAlunos")) {
				return navigate("/dashboard"); // se for assinante, manda pra home
			}

			return navigate("/cursos"); // se não for assinante manda pra /cursos
		}
	};

	useEffect(() => {
		checkAndRedirect();
	}, []);
	return (
		<RedirectionContainer background={background} {...props}>
			{/* Loading... */}
		</RedirectionContainer>
	);
};

export { Redirection };
